/**
 * Single seam for initiating Twitch connect / reconnect.
 * Mock: flips in-memory auth to `linked`.
 * Live: one-line swap to the real OAuth entry (buildTwitchSignInUrl).
 */
import { isStudioUseMock } from '../config';
import { buildTwitchSignInUrl } from '../../utils/authUrls';
import { mockBeginTwitchConnect } from '../api/mockRttsClient';

export type BeginTwitchConnectOptions = {
  /** Where to land after a successful live OAuth round-trip. */
  returnTo?: string;
};

/**
 * Begin sign-in / reconnect with Twitch.
 * @returns true if the caller should navigate client-side (mock);
 *          false if a full-page redirect was started (live).
 */
export function beginTwitchConnect(
  options: BeginTwitchConnectOptions = {}
): boolean {
  if (isStudioUseMock()) {
    mockBeginTwitchConnect();
    return true;
  }

  // Live seam — swap target if the standalone OAuth entry differs later.
  const returnTo = options.returnTo ?? '/studio/vods';
  window.location.href = buildTwitchSignInUrl(returnTo);
  return false;
}
